module.exports = __webpack_public_path__ + "static/media/youtube-circle.0811800e.svg";